import {createSlice, PayloadAction} from "@reduxjs/toolkit";


const homeworkResponseStudentSlice = createSlice({
    name: 'homework',
    initialState: {
        success: false,
        error: null,

    },

    reducers: {
        homeworkSuccess: (state) => {
            state.success = !state.success;
        },
        homeworkErrors: (state, action) => {
            state.error =  action.payload;
            state.success = false;
        },
    },
});



export const { homeworkSuccess,homeworkErrors  } = homeworkResponseStudentSlice.actions;
export const homeworkResponseStudentReducer = homeworkResponseStudentSlice.reducer;

